import ContributorsLayout from './ContributorsLayout';

export default ContributorsLayout;
